import GLightbox from 'glightbox';
import {hasScrollbar, scrollBarWidth} from './scrollBarWidth';

const moduleName = 'popups';

export function popups() {

    const hasScroll = hasScrollbar();
    //const fixedHeader = document.querySelector('.js-fixed-header');

    function toggleModal (modalId) {
        const modal = document.querySelector(`#${modalId}`);
        if (modal) {
            modal.classList.toggle('_opened');
            if (document.querySelectorAll('.modal._opened').length) {
                bodyFixPosition();
                document.body.classList.add('has-modal');

            } else {
                modal.dataset.level = 0;
                bodyUnfixPosition();
                document.body.classList.remove('has-modal');

                document.body.style.paddingRight = '0';
                const activeBtn = document.querySelector('.js-open-modal._active');
                if(activeBtn) activeBtn.classList.remove('_active');
            }
        }
    }

    function windowOnClick (event) {
        const target = event.target;
        if (event.target.classList.contains('modal')) {
            toggleModal(target.id);

        }
    }

    function closeAllModals () {
        document.querySelectorAll('.modal._opened').forEach(modal => {
            toggleModal(modal.id);
            modal.dataset.level = 0;
            document.body.classList.toggle('has-modal');
        });
    }

    document.addEventListener('click', function (e) {
        const target = e.target;

        if (target.classList.contains('js-open-modal') || target.closest('.js-open-modal')) {
            e.preventDefault();
            const modalId = target.dataset.modalId ? target.dataset.modalId : target.closest('.js-open-modal').dataset.modalId;
            const modal = document.querySelector(`#${modalId}`);

            if (!modalId) {
                throw new Error('Не указан ID модального окна или отсутствует обязательный атрибут data-modal-id у триггера.');
            }

            if (!modal) {
                throw new Error(`Не могу найти модальное окно с ID: ${modalId}`);
            }

            const detail = target.dataset.detail;
            if(detail){
                modal.querySelector('form input[name="detail"]').value = detail;
            }

            toggleModal(modalId);
        }

        if (target.classList.contains('js-close-modal')) {
            const modalId = target.closest('.modal').id;
            toggleModal(modalId);
        }
    });

    window.addEventListener('click', windowOnClick);

    window.toggleModal = toggleModal;
    window.closeAllModals = closeAllModals;

    function bodyFixPosition() {
        setTimeout( function() {
            if ( !document.body.hasAttribute('data-body-scroll-fix') ) {
                let scrollPosition = window.pageYOffset || document.documentElement.scrollTop;
                if (hasScrollbar()) {
                    document.body.style.paddingRight = `${scrollBarWidth()}px`;
                    if(document.body.classList.contains('has-fixed-header')){
                        document.querySelector('.js-fixed-header').style.paddingRight = `${scrollBarWidth()}px`;
                    }
                }
                document.body.setAttribute('data-body-scroll-fix', scrollPosition); // Cтавим атрибут со значением прокрутки
                document.body.style.overflow = 'hidden';
                document.body.style.position = 'fixed';
                document.body.style.top = '-' + scrollPosition + 'px';
                document.body.style.left = '0';
                document.body.style.width = '100%';
            }
        } );
    }

    function bodyUnfixPosition() {
        if ( document.body.hasAttribute('data-body-scroll-fix') ) {
            let scrollPosition = document.body.getAttribute('data-body-scroll-fix');

            document.body.style.paddingRight = '0';
            if(document.body.classList.contains('has-fixed-header')){
                document.querySelector('.js-fixed-header').style.paddingRight = '0';
            }

            document.body.removeAttribute('data-body-scroll-fix');
            document.body.style.overflow = '';
            document.body.style.position = '';
            document.body.style.top = '';
            document.body.style.left = '';
            document.body.style.width = '';
            window.scroll(0, scrollPosition);
        }
    }

    const lightbox = GLightbox({
        touchNavigation: true,
        loop: false,
        selector: '.js-zoom-link'
    });

}
